import React ,{useState,useEffect}from 'react'
import Calendar from 'react-calendar';
import $ from "jquery";
import Constants from '../../../Constants';
import { dateFormat } from '../../../services/Util';
export default function DatePickerCalendar(props) {
    const [nextAriaLabel,setNextAriaLabel] = useState('Go to next month')
    const [prevAriaLabel,setPrevAriaLabel] = useState('Go to previous month')
    const [next2AriaLabel,setNext2AriaLabel] = useState('Go to next year')
    const [prev2AriaLabel,setPrev2AriaLabel] = useState('Go to previous year')
    const [viewType,setViewType] = useState('month')
    const viewChange = (action, activeStartDate, value, view) =>{
        setViewType(view)
        if(view === 'month'){
          setNextAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_MONTH)
          setPrevAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_MONTH)
          setNext2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_YEAR)
          setPrev2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_YEAR)
        }
        if(view === 'year'){
          setNextAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_YEAR)
          setPrevAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_YEAR)
          setNext2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_DECADE)
          setPrev2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_DECADE)
        }
        if(view === 'decade'){
            $('.react-calendar__tile--hasActive').addClass("decade-active");
            $('.react-calendar__tile--hasActive').focus()
          setNextAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_DECADE)
          setPrevAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_DECADE)
          setNext2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_CENTURY)
          setPrev2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_CENTURY)
        }
        if(view === 'century'){
            $('.react-calendar__tile--hasActive').addClass("decade-active");
            $('.react-calendar__tile--hasActive').focus()
          setNextAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_CENTURY)
          setPrevAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_CENTURY)
        }
      }
    const showCustomNavigationLabel = (date, label, locale, view) =>{
        return <span aria-label={` date: ${dateFormat(date,'MMMM - YYYY')}`}>{dateFormat(date,'MMMM - YYYY')}</span>
      }
    const selectDate = (value,event) =>{
        var activeClass = 0
        setTimeout(()=>{
          $.each($('.react-calendar__tile'), function( index, value ) {
            var containFirst = value.classList.contains("react-calendar__tile--rangeStart")
            var containLast = value.classList.contains("react-calendar__tile--rangeEnd")
              activeClass = activeClass+ 1
              var arialabel = value?.children[0]?.ariaLabel
              if(containFirst){
                if(viewType === 'month'){
                    $(value).attr('aria-label', "Selected start date "+arialabel);
                  }
                  if(viewType === 'year'){
                     var startMonth = dateFormat(new Date(arialabel),'MMMM')
                     $(value).attr('aria-label', "Selected start month "+startMonth);
                  }
              }else if(containLast){
                if(viewType === 'month'){
                    $(value).attr('aria-label', "Selected end date "+arialabel);
                  }
                  if(viewType === 'year'){
                    var endMonth = dateFormat(new Date(arialabel),'MMMM')
                    $(value).attr('aria-label', "Selected end month "+endMonth);
                 }
              }
        });
        },500)
      }
  return (
    <Calendar
    className={props.className}
    defaultValue={props.defaultValue}
    onChange = {(event) => 
        props.selectDate(event)
    }
    value={props.value}
    navigationLabel={ ({ date, label, locale, view })=>showCustomNavigationLabel(date, label, locale, view)}
    minDate={props.minDate}
    onClickDay={(value, event) => selectDate(value,event)}
    onViewChange={({ action, activeStartDate, value, view }) => viewChange(action, activeStartDate, value, view)}
    nextAriaLabel={nextAriaLabel}
    prevAriaLabel={prevAriaLabel}
    next2AriaLabel={next2AriaLabel}
    prev2AriaLabel={prev2AriaLabel}
      />
  )
}
